import { createContext, useContext } from 'react';

export interface ViewportDimensions {
  readonly width: number;
  readonly height: number;
  readonly iframeX: number;
  readonly iframeY: number;
  readonly iframeWidth: number;
  readonly iframeHeight: number;
}

interface ViewportDimensionsContextProps {
  readonly viewportDimensions: ViewportDimensions | null;
  readonly setViewportDimensions: (dimensions: ViewportDimensions | null) => void;
}

export const ViewportDimensionsContext = createContext<ViewportDimensionsContextProps>({
  viewportDimensions: null,
  setViewportDimensions: () => {},
});

export const useViewportDimensions = () => {
  const context = useContext(ViewportDimensionsContext);

  return context;
};
